import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=338ddb25&scoped=true"
import script from "@/views/Users/Guardian/Guardian.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Guardian/Guardian.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Guardian/guardian.scss?vue&type=style&index=0&id=338ddb25&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ddb25",
  null
  
)

export default component.exports